import Vue from 'vue';
import AuthenticationDialog from './index.vue';

// 返回一个 扩展实例构造器
const AuthenticationDialogConstructor = Vue.extend(AuthenticationDialog);

// 展示弹框
let dialogDom = null;
function showAuthenticationDialog(options) {
  // 单例起飞
  if (showAuthenticationDialog.installed) {
    return dialogDom;
  }

  dialogDom = new AuthenticationDialogConstructor({
    el: document.createElement('div'),
  });
  showAuthenticationDialog.installed = true;
  // 挂载到body中
  document.body.appendChild(dialogDom.$el);

  return dialogDom;
}

export default showAuthenticationDialog;
